import React from 'react';
import styles from './Services.module.scss';
import { licensingAndGuidance } from "../../configration_data/configration";
import { useNavigate } from 'react-router-dom';
import ProtectedPaymentRoute from '../../auth/Auth';

export default function Licensing() {
  ProtectedPaymentRoute()

  const navigate = useNavigate()
  const handleClick = () => {
    navigate("/contact-us")
  }

  return (
    <div className="font-sans antialiased bg-white text-[#202124]">

      {/* Hero Section */}
      <section 
        className="relative overflow-hidden pt-[140px] pb-20 lg:pt-[180px] lg:pb-28 border-b border-[#0f2c4f] flex items-center justify-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2560&auto=format&fit=crop')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Professional Deep Blue Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#021835] via-[#04244d]/90 to-[#04244d]/40 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-[#021835]/50"></div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center flex flex-col items-center justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-[4.2rem] font-medium leading-[1.12] mb-6 tracking-tight text-white max-w-4xl">
            Licensing & Guidance
          </h1>
          <p className="text-lg md:text-[1.15rem] text-white/80 leading-[1.7] font-normal max-w-2xl mx-auto">
            Expert licensing advice and ongoing consultation to ensure your business remains compliant and positioned for growth.
          </p>
        </div>
      </section>

      {/* Expert Guidance and Licensing Assistance */}
      <section className="py-20 lg:py-24 bg-white border-b border-[#f1f3f4]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-4">Expert Guidance & Licensing Assistance</h2>
            <p className="text-[17px] text-[#5f6368] max-w-3xl mx-auto">Our commitment to your business doesn't end with formation. We offer ongoing support to help you navigate challenges and grow your business:</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {licensingAndGuidance.map((ele) => (
              <div key={ele.id} className="flex flex-col gap-4 p-8 rounded-[8px] bg-[#f8f9fa] border border-[#f1f3f4] hover:shadow-[0_2px_12px_rgba(0,0,0,0.04)] transition-shadow duration-300">
                <div className="flex-shrink-0 w-8 h-8 bg-[#e8f0fe] rounded-full flex items-center justify-center text-[#1a73e8]">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                <div>
                  <h3 className="text-[18px] font-semibold text-[#202124] mb-2">{ele.title}</h3>
                  <p className="text-[#5f6368] text-[15px] leading-relaxed">{ele.para}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Box Section */}
      <section className="py-20 lg:py-24 bg-[#f8f9fa] border-b border-[#dadce0]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-xl mx-auto bg-white p-8 lg:p-10 rounded-[12px] border border-[#dadce0] shadow-sm text-center flex flex-col items-center">
            <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">Consult With Our Team</span>
            <h3 className="text-[26px] font-medium text-[#202124] mb-3">Ready to get licensed?</h3>
            <p className="text-[15px] text-[#5f6368] mb-8 leading-relaxed">Connect with our business specialists to map out the exact local, state, and federal permits required for your operations.</p>
            <button 
              onClick={handleClick}
              className="bg-[#1a73e8] text-white px-9 py-3.5 rounded-[4px] font-medium text-[15px] hover:bg-[#1557b0] transition-colors shadow-md cursor-pointer w-full sm:w-auto"
            >
              Get Started
            </button>
          </div>
        </div>
      </section>
    </div>
  )
}

